import { useEffect, useState } from "react";

const DEFAULT_INTERVAL_MS = 60_000;

/** Minute-level clock for header timing; does not refetch APIs. */
export function useNowMs(intervalMs: number = DEFAULT_INTERVAL_MS): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => {
      setNowMs(Date.now());
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return nowMs;
}
